module.exports = __webpack_public_path__ + "img/star-map_black.cf7a47e.png";